/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * List of the conditions defining content of the domain
 */
export type PublicFilterDomainConditionDto = {
    /**
     * Type of the condition
     */
    type: PublicFilterDomainConditionDto.type;
};

export namespace PublicFilterDomainConditionDto {

    /**
     * Type of the condition
     */
    export enum type {
        SOURCE = 'SOURCE',
        TAG = 'TAG',
        ASSET = 'ASSET',
    }


}
